import { currencyCodes } from "../../../../../../ProductTile/constants.js";
const getFormattedPrice = (price, locale) => {
  return new Intl.NumberFormat(locale, {
    currency: currencyCodes[locale],
    maximumFractionDigits: 2,
    style: "currency"
  }).format(price).replace("US", "").trim();
};
export {
  getFormattedPrice
};
